// Colour-mode palette in SudokuPad's order (1–9), drawn in pale tints that match the Paper
// theme. The mockup samples #F9D7BA, #9ED8A8, #A9C1F2 and #F2A7C3 are four of them.
export const PALETTE: readonly string[] = [
  '#D6D3CC', // 1 grey
  '#A8A49C', // 2 dark grey
  '#4A4743', // 3 near black
  '#9ED8A8', // 4 green
  '#F2A7C3', // 5 pink
  '#F9D7BA', // 6 orange
  '#F0A09A', // 7 red
  '#FFE58F', // 8 yellow
  '#A9C1F2', // 9 blue
];

export function colourOf(index: number): string {
  return PALETTE[(index - 1 + PALETTE.length) % PALETTE.length]!;
}
